export default __webpack_public_path__ + "static/media/img (3).e1784cb9.jpg";